import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { FC } from 'react';
import { TextFieldWithDataReferences } from '../../../../../../Components/Wysiwyg';

export interface IConditionDataInputProps {
    operand: string;
    handleOperandChange: (value: string) => void;
    errorMessage?: string;
    dataReferences: string[];
}

export const ConditionDataInput: FC<IConditionDataInputProps> = (props) => {
    const { errorMessage, operand, handleOperandChange, dataReferences } = props;

    return (
        <FormControl error={!!errorMessage} fullWidth required>
            <FormLabel>Value</FormLabel>
            <TextFieldWithDataReferences initialValue={operand} onChange={handleOperandChange} dataReferences={dataReferences} />
            <FormHelperText>{errorMessage}</FormHelperText>
        </FormControl>
    );
};
